var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 586 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-13,.cls-14,.cls-9{isolation:isolate;}.cls-2{fill:#e5e5e5;mix-blend-mode:multiply;}.cls-3{fill:#ffde83;stroke-miterlimit:10;}.cls-3,.cls-4{stroke:#3a3836;}.cls-4,.cls-8{fill:none;}.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-13,.cls-14,.cls-5,.cls-9{opacity:0.7;}.cls-6,.cls-9{fill:#ff6c37;}.cls-7{fill:url(#linear-gradient);}.cls-10{fill:#3a3836;}.cls-11{fill:url(#linear-gradient-2);}.cls-12{fill:url(#linear-gradient-3);}.cls-13{fill:url(#linear-gradient-4);}.cls-14{fill:url(#linear-gradient-5);}.cls-15{fill:#1da1f2;}.cls-16{fill:#e24329;}.cls-16,.cls-17,.cls-18{fill-rule:evenodd;}.cls-17{fill:#fc6d26;}.cls-18{fill:#fca326;}.cls-19{fill:#6922ac;}.cls-20{fill:#6923ac;}.cls-21{fill:#f1622d;}.cls-22{fill:#fffaf6;}.cls-23{fill:#fff8f5;}.cls-24{fill:#fff7f2;}.cls-25{fill:#0061ff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 212.7,
    y1: 988.2,
    x2: 217.45,
    y2: 988.2,
    gradientTransform: "translate(0 -918)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fe7304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fc7c0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f88b15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#f3a125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#ecbd39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebc03b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 414.99,
    y1: 970.2,
    x2: 417.4,
    y2: 970.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 421.21,
    y1: 959.5,
    x2: 424.78,
    y2: 959.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 487.95,
    y1: 1016.7,
    x2: 494.8,
    y2: 1016.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 476.94,
    y1: 957.75,
    x2: 486.28,
    y2: 957.75,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.83,151.9h-5.18a7.51,7.51,0,0,1-4.85,6.32c-8,2.94-9.8-6-9.8-6l0-.3H107.11c-1.37,3.69-3.45,6.83-6.54,6.7-6-.24-7.38-4-7.59-6.7H89.86a3.85,3.85,0,0,0,0,7.7h48a3.85,3.85,0,0,0,0-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384.43,151.9H371.28c-2.07,2.8-2.16,2.83-5.26,2.7-6-.24-4.14-.9-6.58-2.7h-3.12a3.85,3.85,0,1,0,0,7.7h46a3.85,3.85,0,1,0,0-7.7h-5.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M540.81,151.9h-7.88c-1.52,2.32.38,2.16-2.74,3.3-8,2.94-9.2-3-9.2-3l0-.3H508.1c-1.5,3.09-2.45,4.83-5.54,4.7-6-.24-7.38-2-7.59-4.7h-2.12a3.85,3.85,0,0,0,0,7.7h48a3.85,3.85,0,1,0,0-7.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 178.73,
    y: 103.11,
    width: 11.83,
    height: 13.78,
    rx: 1.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.1,
    cy: 27.8,
    r: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 186.2,
    y1: 50.9,
    x2: 186.9,
    y2: 52.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 190.2,
    y1: 46,
    x2: 191.9,
    y2: 46.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 188.1,
    y1: 39,
    x2: 189,
    y2: 37.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 181.1,
    y1: 37.7,
    x2: 180.5,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 177.2,
    y1: 42.9,
    x2: 175.1,
    y2: 42.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 178.5,
    y1: 49.9,
    x2: 177.4,
    y2: 51.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 284.5,
    cy: 75.6,
    r: 19.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289.2,131.4v19.2a7.6,7.6,0,0,1-7.6,6.8h0a7.55,7.55,0,0,1-7.6-7,596.39,596.39,0,0,1-2.1-59.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M301.5,85.3c8.7,6.6,20.5,24.6,23.6,30.7,3.5,6.9-3,9.7-3,9.7s-4.3,2.1-8.3-3.3c-3.2-4.5-7.6-10.9-9.1-12.9,0,0-.1-.1-.1,0s-.1.1,0,.1l2.9,10.5,8,27.8a7.44,7.44,0,0,1-5.6,8.9,9.85,9.85,0,0,1-1.7.2h-.5a7.33,7.33,0,0,1-7-5l-7.8-18.8-4.8-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M305.2,110.1s-7-8.2,0-21.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M305.3,110.7s-13.1-9-7.1-21.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.9,87.2s-.1,11.7,3.4,18.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 287.1,
    y1: 54,
    x2: 287.1,
    y2: 56.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.3,104h-4.1a.43.43,0,0,1-.4-.4V99.4a.43.43,0,0,1,.4-.4h4.1a.43.43,0,0,1,.4.4v4.2A.43.43,0,0,1,292.3,104Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M309,92.8V86.3a2.26,2.26,0,0,0-2.3-2.3h-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M308.6,115.6a2.84,2.84,0,0,1-1.3.4h-1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 287.5,
    cy: 50.7,
    r: 2.7
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 287.5,
    cy: 51.1,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.5,68.6a30.31,30.31,0,0,1,8.5-.3c7.7.6,10.8,3.6,12.1,5.6a7.79,7.79,0,0,1,.5,4c-.5,3.5-1.1,12-16.8,11.3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 296.3,
    cy: 78,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.5,87.2c-4.2-1.4-11.2-5.1-15.4-10.9a5.94,5.94,0,0,0-8.4-1.2l-.1.1h0a5.88,5.88,0,0,0-1.7,7.2c2.6,5.6,10.7,17.6,28.3,23.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.4,72.5a29.87,29.87,0,0,1,1,5.2A19.41,19.41,0,1,1,127.6,64S132.4,67.7,133.4,72.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.3,91.2c-9,6.2-19.6,21.1-22.9,27.1-3.8,6.8,2.6,9.8,2.6,9.8s4.2,2.3,8.4-3c3.4-4.4,7.9-9.3,9.4-11.3l-.5,11.3L92.6,150a8.08,8.08,0,0,0,0,3.1,7.59,7.59,0,0,0,7.2,5.8h0c4.1.1,6.3-2.7,7.7-7.2l4.8-16.1,5.1-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.7,114.1s5.3-7.6-.9-20.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.7,115.8s9.2-11,4.3-23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.1,98.6l-.7-5.8a2.21,2.21,0,0,1,2.2-2.4l5.9-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.4,69.5c-2.4.2-4.3.6-8.7,1.1-7.6.9-10.6,4.1-11.8,6.2a6.87,6.87,0,0,0-.3,4c.7,3.8,3.8,12.8,18.2,10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.9,101s1.3,15.3,1.1,20l.7,30.1a7.24,7.24,0,0,1-7.2,7.5h-.3a7.49,7.49,0,0,1-7.2-6.4L116.4,133"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.53,89.21s3.27,8.19-.63,11.69c0,0,0-6.18-2.62-7.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 108.9,
    y1: 58,
    x2: 109.7,
    y2: 60
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 107.9,
    cy: 54.8,
    r: 2.7
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 108,
    cy: 55.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.5,117.91l-.1,2.39a2.37,2.37,0,0,0,2.3,2.5h.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.1,107.3H120a.43.43,0,0,1-.4-.4v-4.2a.43.43,0,0,1,.4-.4h4.1a.43.43,0,0,1,.4.4v4.2A.37.37,0,0,1,124.1,107.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132,90.65c1.2,4.6,5.5,10.55,7.8,11,2.1.4,4.1.7,6.1-1.2,2.1-2.1,4.1-2.1,6.2,0a6.25,6.25,0,0,1,0,8.3c-4.5,4.4-8.6,5.7-11.8,5.7a27.1,27.1,0,0,1-4-.4s-3.2-.8-4.2-2.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 148.2,
    cy: 82.6,
    rx: 3,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 148.3,
    cy: 82.4,
    rx: 5,
    ry: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 148.3,
    y1: 95,
    x2: 148.3,
    y2: 99.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149,92.24s1.71-1.94,7.21-1.64a14.64,14.64,0,0,1,5,1.2A11.8,11.8,0,1,0,155.7,74s-3.36,5-6.56-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.2,75.1s-3.5,6.9.5,11.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160,77.9s4.4,2.7,10.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.2,82.2a10.9,10.9,0,0,0-6.1,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.8,86.5h-.6a5.91,5.91,0,0,1-5.9-5.9,5.9,5.9,0,0,1,11.8,0,4.1,4.1,0,0,1-.1,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.4,75.2a13.85,13.85,0,0,1,1.1,5.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "167.6 84.6 169.1 82.9 170.8 84.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 169.1,
    y1: 83.9,
    x2: 169.1,
    y2: 87.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.7,58.8a12.42,12.42,0,0,1,16.2,7,12.58,12.58,0,0,1-1.2,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.2,79.2a12.45,12.45,0,1,1-17.6-17.6,8.06,8.06,0,0,1,1.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.9,70.2l-.1-.1c-4.5-7-12.9-6.8-17.2.3l-.3.4h0c4.4,7,12.8,7,17.2,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 215.1,
    cy: 70.2,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 215.1,
    cy: 70.2,
    r: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M257.8,31.9a9.65,9.65,0,1,0-.5,19.3h.6a8,8,0,0,0,3.4-.7l6.9,3.8L266,46.6a9.7,9.7,0,0,0-3.1-13.3A10,10,0,0,0,257.8,31.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.8,31.9a9.65,9.65,0,1,0-.5,19.3h.6a8,8,0,0,0,3.4-.7l6.9,3.8L266,46.6a9.7,9.7,0,0,0-3.1-13.3A10,10,0,0,0,257.8,31.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 254.2,
    y1: 38.5,
    x2: 261.8,
    y2: 38.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 254.2,
    y1: 41.5,
    x2: 261.8,
    y2: 41.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 254.2,
    y1: 44.5,
    x2: 261.8,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 335,
    y1: 52.8,
    x2: 335.7,
    y2: 54.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 339.8,
    y1: 47.7,
    x2: 341.5,
    y2: 48.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 336.8,
    y1: 40.9,
    x2: 337.7,
    y2: 39.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 330.9,
    y1: 39.7,
    x2: 330.2,
    y2: 37.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 326.9,
    y1: 44.8,
    x2: 324.8,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 328.2,
    y1: 51.8,
    x2: 327.1,
    y2: 53.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M389.4,78a2.76,2.76,0,0,1,1.6,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.2,78.8c.5-1,1.4-1.3,2.8-1.3h1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355.4,109.5H354a2.89,2.89,0,0,1-3.1-2.5V96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M354.8,60.5a3.14,3.14,0,1,1,1.5-6.1c.1,0,.1,0,.2.1a3.36,3.36,0,0,1,1.6,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M354.8,60.5a3.14,3.14,0,1,1,1.5-6.1c.1,0,.1,0,.2.1a3.36,3.36,0,0,1,1.6,1"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 372.6,
    cy: 68.3,
    r: 19.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355.1,104.9l2.9,42.7a7.7,7.7,0,0,0,7.5,7.1h0a7.54,7.54,0,0,0,7.7-7.2l-.3-16.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 386.1,
    y1: 82.1,
    x2: 386.1,
    y2: 82.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 367.9,
    y1: 131.4,
    x2: 380.3,
    y2: 131.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355.7,105.7s8.38-7.17,5.08-22.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M359.5,82.3l-3.1-.2c-4.3-1.5-11.6-6.4-15.9-12.4a6.2,6.2,0,0,0-8.6-1.3c-.1,0-.1.1-.2.1h0a6.19,6.19,0,0,0-1.7,7.4c2.7,5.8,6.5,15.2,24.6,21.2l.5,7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M386.8,82h0a12.3,12.3,0,0,0,4.3-1A32.46,32.46,0,0,0,404,71a6.2,6.2,0,0,1,8.6-1.3l.2.2h0a6.22,6.22,0,0,1,1.8,7.4c-2.7,5.8-7.2,13.6-23,20.4L391,105"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M354.6,97.1s4.6-5.2,1.8-14.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391,80.7s-2.5,9,.6,17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M356.9,134.5l-1.2-.3a6.53,6.53,0,0,1-3.3-1.9c-1.7-1.9-1.6-3.9-1.3-6l.1-1.2c.4-2.7,2.4-4.6,4.7-4.4h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M373.8,138.2s23,6.9,17.2-33.1c0,0-6.6-10.3-4.1-23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.1,90.6h3.4a.79.79,0,0,1,.8.8V95a.79.79,0,0,1-.8.8h-3.4a.79.79,0,0,1-.8-.8V91.4C378.2,90.9,378.6,90.6,379.1,90.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 419.3,
    cy: 46.9,
    r: 10.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 416.1,
    cy: 42.4,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 416.2,
    cy: 52.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 416.2,
    cy: 52.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 416.2,
    cy: 52.2,
    r: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 416.1,
    y1: 43.2,
    x2: 416.1,
    y2: 50.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M423,44l.1,1.8c0,.8.2,2.2-.4,2.2h-4.8c-1,0-1.7,0-1.7.9v1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "421.6 46.2 423 45.2 424.4 46.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 423,
    cy: 41.5,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 423,
    cy: 41.5,
    r: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391.2,64.63c-.8,5.6-6.5,12.37-14.2,12.67-8.4.3-15.3-6.1-15.5-12a14.7,14.7,0,0,1,.6-5.9c1.2-3,4.7-5.1,14.2-5.5a29.49,29.49,0,0,1,9.8,1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 562.1,
    y1: 72.1,
    x2: 562.8,
    y2: 74.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 566.1,
    y1: 67.2,
    x2: 567.8,
    y2: 67.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 564,
    y1: 60.1,
    x2: 564.9,
    y2: 58.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 557,
    y1: 58.9,
    x2: 556.4,
    y2: 57.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 553,
    y1: 64.1,
    x2: 551,
    y2: 63.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.4,
    y1: 71.1,
    x2: 553.3,
    y2: 72.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 445.7,
    y1: 98.4,
    x2: 446.3,
    y2: 100.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 433.7,
    y1: 86.1,
    x2: 431.9,
    y2: 85.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 435.1,
    y1: 96,
    x2: 434.1,
    y2: 97.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 237.6,
    y1: 129.9,
    x2: 238.6,
    y2: 132.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 242.8,
    y1: 124.2,
    x2: 245.4,
    y2: 124.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 241,
    y1: 116,
    x2: 242.8,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 231.5,
    y1: 114,
    x2: 230.7,
    y2: 111.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 225.6,
    y1: 120.5,
    x2: 223.4,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 228.4,
    y1: 129.1,
    x2: 226.9,
    y2: 131.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 190.9,
    y1: 119.6,
    x2: 191.6,
    y2: 121.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 194.6,
    y1: 109.9,
    x2: 196.9,
    y2: 110
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191.5,
    y1: 101.9,
    x2: 192.5,
    y2: 100.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 179.2,
    y1: 100.2,
    x2: 178.5,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 174.3,
    y1: 109.5,
    x2: 172.3,
    y2: 109.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 177.5,
    y1: 118.9,
    x2: 176.2,
    y2: 120.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 181,
    y: 106.1,
    width: 7,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 181,
    y: 108.7,
    width: 7,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 181,
    y: 111.29,
    width: 3.9,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M439.4,82.2h10.3a1.54,1.54,0,0,1,1.5,1.5v9.1a1.54,1.54,0,0,1-1.5,1.5H439.4a1.54,1.54,0,0,1-1.5-1.5V83.7A1.54,1.54,0,0,1,439.4,82.2Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "439.8 88.8 442.3 88.8 443.7 85.4 445.4 91 447.4 86.6 448.5 89.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 439,
    y1: 78.6,
    x2: 438.8,
    y2: 77.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 449.6,
    y1: 78.3,
    x2: 450.6,
    y2: 76.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 456.3,
    y1: 95.1,
    x2: 454.6,
    y2: 94.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 456.6,
    y1: 85.3,
    x2: 454.8,
    y2: 86.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 460.7,
    cy: 119.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.6,
    cy: 46.1,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M528.4,120.6s16.6-3.7,21.8,16.3c0,0,12.9-2.8,16.5,10.1a6.93,6.93,0,0,1,.3,2h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.9,139.6s-24.6-14.3-40.4,8.6H30.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 567.2,
    y1: 149,
    x2: 584.7,
    y2: 149
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M508.8,130l-.4,19.7c-.4,3.9-2.7,6.8-6.6,6.8h0a7.55,7.55,0,0,1-7.6-7c-1-11.5-.4-11.54.1-35.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M527.6,120.7l5,26.1c1.1,4.7-.5,9.1-5.3,9.1h-.5a7.33,7.33,0,0,1-7-5L512.7,131l-4.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M524.6,106.2s-6.5-4.1.5-17.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M522.2,103.8c-2.5-3.5-6.7-9.6-2.7-17.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M529.2,93.7V85a2,2,0,0,0-2-2h-5.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 507.5,
    y1: 52.8,
    x2: 507.2,
    y2: 55.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 507.7,
    cy: 49.5,
    r: 2.7
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 507.7,
    cy: 49.9,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 510.6,
    cy: 74.5,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M490.1,87.1a22,22,0,0,1-1.4-1.8c-.3-.4-.6-.9-.9-1.4A19,19,0,1,1,513.7,91a19.43,19.43,0,0,1-9.4,2.5h-.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M490.1,113.6H507a.86.86,0,0,0,.8-.8v-.2L502.2,88a.76.76,0,0,0-.8-.6H476.7a.79.79,0,0,0-.8.8v.2l4.2,17.6.5,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M480.5,108.4l1.5-2.1a5.3,5.3,0,0,1,7.4-1.3c.1.1.2.1.3.2h0a5.32,5.32,0,0,1,1.1,7.2l-1.4,2.1A5.42,5.42,0,0,1,482,116c-.1-.1-.2-.1-.3-.2h0A5.49,5.49,0,0,1,480.5,108.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M527.8,109.3s-12-12.4-17.4-9.3,2.3,12,2.3,12,14.3,17.4,20.8,3.1c6-13.2-12.7-31.1-12.7-31.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 511.6,
    y1: 111.1,
    x2: 507,
    y2: 113.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 506.7,
    y1: 106.6,
    x2: 509.3,
    y2: 106.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 491.4,
    cy: 98.7,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 491.4,
    cy: 98.7,
    r: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M490.7,63a11.51,11.51,0,0,1,5.5,8.2c1.1,6.3-1.1,12.4-7.1,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M490.6,49.8,488.4,44h-.1a8.35,8.35,0,1,0-11.6,2.2,8.25,8.25,0,0,0,7.9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M486.3,38.2a2.69,2.69,0,0,0-2.7-2.7,2.66,2.66,0,0,1-3.8,0,2.69,2.69,0,0,0-2.7,2.7,2.81,2.81,0,0,0,1,2.1h0l4,3.7,3.7-4h0A3.45,3.45,0,0,0,486.3,38.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M486.3,38.2a2.69,2.69,0,0,0-2.7-2.7,2.66,2.66,0,0,1-3.8,0,2.69,2.69,0,0,0-2.7,2.7,2.81,2.81,0,0,0,1,2.1h0l4,3.7,3.7-4h0A3.45,3.45,0,0,0,486.3,38.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 16.8,
    cy: 92.5,
    r: 13.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 430.5,
    cy: 125.1,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 566.5,
    cy: 35.1,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M14,99.3a9.41,9.41,0,0,0,9.4-9.2v-.5A6.48,6.48,0,0,0,25,87.9a5.92,5.92,0,0,1-1.9.5,3.1,3.1,0,0,0,1.4-1.8,4.85,4.85,0,0,1-2.1.8,3.29,3.29,0,0,0-4.6-.2,3.1,3.1,0,0,0-1,2.4,2.2,2.2,0,0,0,.1.8A9.56,9.56,0,0,1,10.1,87a3.29,3.29,0,0,0-.4,1.7,3.06,3.06,0,0,0,1.5,2.7A4.19,4.19,0,0,1,9.7,91h0a3.23,3.23,0,0,0,2.6,3.2,3.81,3.81,0,0,1-1.5.1,3.48,3.48,0,0,0,3.1,2.3,7.6,7.6,0,0,1-4.1,1.5A2.2,2.2,0,0,1,9,98a10.63,10.63,0,0,0,5,1.3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 65.8,
    cy: 41.5,
    r: 13.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 579.8,
    cy: 104,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 374,
    cy: 15.7,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-_-Group-24",
    "data-name": "Fill-1- -Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "cls-16",
    d: "M65.9,48.9h0l2.9-9.1H63l2.9,9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "cls-17",
    d: "M65.9,48.9,63,39.8H58.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "cls-18",
    d: "M58.9,39.8h0L58,42.6a.62.62,0,0,0,.2.7l7.7,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    className: "cls-16",
    d: "M58.9,39.8H63l-1.8-5.5c-.1-.2-.2-.2-.4-.2s-.1.1-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    className: "cls-17",
    d: "M65.9,48.9l2.9-9.1H73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    className: "cls-18",
    d: "M73,39.8h0l.9,2.8a.62.62,0,0,1-.2.7l-7.8,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    className: "cls-16",
    d: "M73,39.8H68.9l1.8-5.5c.1-.2.2-.2.4-.2s.1.1.2.2Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "jmLRxk.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M426.1,133.3c.2.1.4.3.6.3a2,2,0,0,0,1.3-.1,1,1,0,0,0,.5-.6,1.8,1.8,0,0,0,.2-1,3.32,3.32,0,0,0-.5-1.6,2,2,0,0,0-1.1-.9c-.2,0-.3-.1-.5-.1h0a2.23,2.23,0,0,1,1.4.3,2.7,2.7,0,0,1,.7.8,1.69,1.69,0,0,1,.3,1c0,.1,0,.1.1.1h.5v-4.3h1.1l-.1-.1a5.73,5.73,0,0,1-1.1-1.1c-.1-.1-.1-.1,0-.2l.1.1a5.72,5.72,0,0,0,1.6,1.1,1.42,1.42,0,0,0,.6.2,1.39,1.39,0,0,0,1.1-.2,5.5,5.5,0,0,0,.9-.7v.2c-.1.1-.1.2-.2.3v.1a.6.6,0,0,0,.4.1h.7a2.38,2.38,0,0,0,.5-1.8,1.42,1.42,0,0,0-.2-.6,2.18,2.18,0,0,0-.5-.8v-.9a2,2,0,0,0-.3-1.1l-.9-1.2-.2-.2h0a3.92,3.92,0,0,1,1,.8c0-.1.1-.1.1-.2v-.2a1.7,1.7,0,0,1-.1-.7v-.5a1.27,1.27,0,0,0-.1-.6v-.1h0a1.42,1.42,0,0,1,.2.6,2.11,2.11,0,0,0,.5,1.3,2.65,2.65,0,0,0,.5.6.31.31,0,0,0,.2.1.37.37,0,0,0,.3-.1v-.6a3.81,3.81,0,0,0-.8-1.7l-.3-.3a.62.62,0,0,0-.7-.2c-.2,0-.3.1-.5.3s-.3.3-.4.4a1.14,1.14,0,0,1-.8.3H432l-.7-.1.2-.2h0l-.2.1-.3.6h0l.2-.2h0c-.2.1-.3.2-.5.2,0-.1.1-.2.2-.3h-.2a2.19,2.19,0,0,0-.5.3h-.1c-.3.1-.6.1-.9.2h-.1a1.79,1.79,0,0,1-.7-.5c-.1-.1-.2-.2-.2-.3a.68.68,0,0,0-.8-.4,1.42,1.42,0,0,0-.6.2l-.7.2h.4l-.3.1c-.1,0-.2.1-.3.1h.3a4.7,4.7,0,0,0-.9.6l.4-.1a.1.1,0,0,1-.1.1c-.1.1-.1.2-.2.2a.62.62,0,0,0-.1.7,2.38,2.38,0,0,0,.6,1.1l.5.5a.76.76,0,0,0,.5.2h.1a4.88,4.88,0,0,0,.7-.3.6.6,0,0,0,.3-.6,1.1,1.1,0,0,0,0-.8,11,11,0,0,0-.2-1.8v-.1h0a12.09,12.09,0,0,1,.5,1.8,4.87,4.87,0,0,1,.1,1.2.37.37,0,0,1-.1.3,1,1,0,0,1-.4.5,1.48,1.48,0,0,1-1.3,0,.1.1,0,0,1-.1-.1h0a4.87,4.87,0,0,0-.1,1.2v.1a1.48,1.48,0,0,1,.1.7.6.6,0,0,0,.1.4c0-.1.1-.2.1-.3a.9.9,0,0,0,.1.5v.1a.37.37,0,0,1,.1-.3c.1.1.1.2.2.3v.1c0,.1.1.3.1.4h0v-.3h0a1.14,1.14,0,0,1,.3.8v.6a.91.91,0,0,1-.3.7,4.35,4.35,0,0,1-.7.6,6.73,6.73,0,0,1-1.1.7,2.36,2.36,0,0,0-.8.9,1.27,1.27,0,0,0-.1.6.52.52,0,0,0,.2.4,2.65,2.65,0,0,1,.5.6l.1.2h-1.6V117.9h14.1v8.4h.4V133a.1.1,0,0,1-.1.1h-8.4v-1.4h-.5a2.92,2.92,0,0,1-.2.9c-.1.2-.1.3-.2.4a1.7,1.7,0,0,1-1,.6,2,2,0,0,1-.8-.1,1.33,1.33,0,0,1-.6-.5.37.37,0,0,1-.1-.3Zm11.4-.7v-5.2h0l-1.5.1-2.8.2h-.1l-.2.2a1.49,1.49,0,0,1-.9.2l-.9-.3H430v5.3c0,.1,0,.1.1.1l1.1-.1,2.1-.1,2.1-.1,2.1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M431,122.4a.37.37,0,0,1,.3.1c.1,0,.1.1,0,.1s-.1.1,0,.2a.75.75,0,0,1-.1.8h-.1a2.92,2.92,0,0,0-.9.2h-.1a.78.78,0,0,1-.1-1.1h0a.52.52,0,0,1,.4-.2A1.27,1.27,0,0,1,431,122.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M434,126.2a.76.76,0,0,1-.5-.2,1.38,1.38,0,0,0-.4-.3c-.1-.1-.1-.1-.1-.2s.1-.2.2-.3a1.27,1.27,0,0,1,.6-.1h.8a.22.22,0,0,1,.2.2h0c0,.1,0,.1-.1.2a1,1,0,0,1-.4.5C434.3,126.2,434.1,126.2,434,126.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M433.5,122.4a.37.37,0,0,1,.3-.1.65.65,0,0,1,.6.6v.6h0a.6.6,0,0,0-.4-.1h-.1l-.1-.1-.3-.6c0-.1,0-.1.1-.2s.1-.1,0-.1Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "430.3 132.6 430.3 132 431.8 130.3 433.1 130.8 434.5 129 435.8 130.1 437.1 128 437 132.1 430.3 132.6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "nm1JHk"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M566.5,43.1a8,8,0,1,1,8-8v.1A7.94,7.94,0,0,1,566.5,43.1ZM563,39.4h0l-.1-.1h0c0-.1,0-.1-.1,0h0l-.2.2h0l-.3.3s-.1,0,0,.1.1,0,.1,0l1.1.1h.3l-.2-.2h0Zm.5.2h0l.1-.2a2,2,0,0,1-.1-.5c0-.2,0-.2.1-.2l.2-.1a25.29,25.29,0,0,0,2.2-1.3,7,7,0,0,0,1-.8v-.1l-.5-.5h-.1l-1,.2c-.1,0-.2.1-.3.1l-.8.8-1.5,1.5v.1l.8.8c-.2.2-.2.2-.1.2Zm5.7-7.4a.52.52,0,0,0-.4-.2,1.27,1.27,0,0,0-.6.1,2.41,2.41,0,0,0-.8.6c-.7.6-1.4,1.3-2.1,2v.1l.5.5h.1l.3-.3,2.4-2.4a.68.68,0,0,1,.6-.4Zm0,.1a.37.37,0,0,0-.3.1l-.3.3-1.9,1.9-.7.7s-.1,0,0,.1l.3.3h.1l.2-.2,1.7-1.5,1.1-1a.44.44,0,0,0,.1-.5c0-.1-.1-.2-.3-.2Zm1-2.2a1.22,1.22,0,0,0-1.2,1.2,1.33,1.33,0,0,0,.3.8,1.24,1.24,0,0,0,1.4.4c.1,0,.1,0,0-.1l-.7-.8c-.1-.1-.1-.1,0-.2a9.43,9.43,0,0,0,1-1v-.1a1.08,1.08,0,0,0-.8-.2Zm-.6,3h0l-1.8,1.6c-.4.4-.9.8-1.3,1.2V36l.5.5h.1c.6-.6,1.2-1.2,1.8-1.9a4.13,4.13,0,0,0,.7-1.1v-.4Zm1.9-1.7a1.61,1.61,0,0,0-.3-.9h-.1l-.2.2-.7.7s-.1.1,0,.1l.7.7h.1a.89.89,0,0,0,.5-.8Zm-5.9,4h0l-.5-.5H565l-.4.4-.3.3v.1h.2Zm.5.5-.3-.3h-.1l-.4.4v.1h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M563.4,39.6h0l-.8-.8v-.1l1.5-1.5.8-.8a.37.37,0,0,1,.3-.1l1-.2h.1l.5.5v.1c-.3.3-.7.5-1,.8a15.92,15.92,0,0,1-2.2,1.3l-.2.1c-.1.1-.1.1-.1.2a4.33,4.33,0,0,1,.1.5v.1S563.5,39.6,563.4,39.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M569.2,32.2c-.3,0-.4.2-.6.4l-2.4,2.5-.3.3h-.1l-.5-.5v-.1c.7-.7,1.4-1.3,2.1-2,.3-.2.5-.4.8-.6a.66.66,0,0,1,.6-.1C568.9,32,569.1,32.1,569.2,32.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M569.2,32.3c.2,0,.3.1.4.3s0,.3-.1.5l-1.1,1-1.7,1.5-.2.2h-.1l-.3-.3v-.1l.7-.7,1.9-1.9.3-.3C568.9,32.3,569.1,32.3,569.2,32.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M570.2,30.1a1.88,1.88,0,0,1,.8.2v.1l-1,1c-.1.1-.1.1,0,.2l.7.7c.1.1.1.1,0,.1a1.29,1.29,0,0,1-1.2-2.2.82.82,0,0,1,.7-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M569.6,33.1c0,.1-.1.3-.1.4a6.73,6.73,0,0,1-.7,1.1c-.6.7-1.2,1.3-1.8,1.9h-.1l-.5-.5v-.1c.4-.4.9-.8,1.3-1.2l1.9-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M571.5,31.4a1.19,1.19,0,0,1-.5.9h-.1l-.7-.7v-.1l.7-.7.2-.2h.1A1.14,1.14,0,0,1,571.5,31.4Zm-.3-.1v-.2l-.1-.1-.1.1h0a.19.19,0,0,1,0,.3v.1h.1C571.3,31.6,571.3,31.5,571.2,31.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M562.7,39.2h0l.3.2h0l-1.1-.1h-.1v-.1l.3-.3h0l.2-.2h.1m.1.1h0a4,4,0,0,1,.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M565.6,35.4l-1.2.2h-.2v-.1l.3-.3.4-.4s0-.1.1,0l.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M566.2,35.9l-.6.1h-.3v-.1l.4-.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M571.2,31.3a.37.37,0,0,1-.1.3H571v-.1h0a.19.19,0,0,0,0-.3v-.1h0c.1,0,.1,0,.1.1A.1.1,0,0,1,571.2,31.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M374.2,11.2l-4,2.6,4,2.6-4,2.6-4-2.6,4-2.6-4-2.5,4-2.6Zm-4,8.5,4-2.6,4,2.6-4,2.5Zm4-3.4,4-2.6-4-2.5,4-2.6,4,2.6-4,2.6,4,2.6-4,2.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320.28,151.9h-5.17c-.44,2.65-.74,3.18-3.85,4.32-8,2.94-10.8-4-10.8-4l0-.3H289.57c-1.37,3.69-4.45,5.83-7.55,5.7-6-.24-7.38-3-7.58-5.7h-2.12a3.85,3.85,0,1,0,0,7.7h48a3.85,3.85,0,1,0,0-7.7Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToon);
export default __webpack_public_path__ + "static/media/toon.d3da12776e6f2f03c589282053789222.svg";
export { ForwardRef as ReactComponent };